import { render, staticRenderFns } from "./courseCatalogue.vue?vue&type=template&id=79d23246&scoped=true&"
import script from "./courseCatalogue.vue?vue&type=script&lang=js&"
export * from "./courseCatalogue.vue?vue&type=script&lang=js&"
import style0 from "./courseCatalogue.vue?vue&type=style&index=0&id=79d23246&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d23246",
  null
  
)

export default component.exports